<div>
  <p class="retrofit-task-item-title" [ngSwitch]="selectRetrofitContractor">
    <span *ngSwitchCase="700000000">
      Contractor Information
    </span>
    <span *ngSwitchCase="700000001">
      Do it Myself
    </span>
    <span *ngSwitchDefault>
      Who will do the retrofit?
    </span>
  </p>

  <form [formGroup]="formContractorInfo">
    <div>
      <div [ngSwitch]="selectRetrofitContractor">
        <div *ngSwitchCase="700000000">
          <div
            *ngIf="application._Ebb_ContractorId !== application._Ebb_OwnerId &&
                   application._Ebb_ContractorId; else: searchContractor">
            <span style="font-size: 15px; font-weight: 500;">
              {{ taskRetrofitContractorSummary }} ({{ retrofitContractor?.businessName }})
            </span>
            <div *ngIf="retrofitContractor">
              <span class="retrofit-task-business-info">
                Email: {{ retrofitContractor.emailAddress2?retrofitContractor.emailAddress2:retrofitContractor.emailAddress1 }}
              </span>
              <span class="retrofit-task-business-info">
                Phone: {{ this.utilityService.formatPhone(retrofitContractor.address2_Telephone1) }}
              </span>
              <div class="retrofit-task-business-info">
                Website:
                <span
                  *ngIf="retrofitContractor &&
                         retrofitContractor.webSiteUrl &&
                         retrofitContractor.webSiteUrl.length > 0; else: noBizWeb">
                  {{ retrofitContractor.webSiteUrl }}
                </span>
                <ng-template #noBizWeb> <span>N/A</span> </ng-template>
              </div>
              <div *ngIf="!isManualContractor() && IsContractorInDirectory()">
                <div [ngSwitch]="application.contractorInvitationCode"
                  class="retrofit-task-business-info">
                  <span *ngSwitchCase="700000001">
                    Contractor has not yet responded to the invitation to upload documents on your behalf.
                  </span>
                  <span *ngSwitchCase="700000002">
                    Contractor has accepted the invitation to upload documents on your behalf.
                  </span>
                  <div *ngSwitchCase="700000003" fxLayout="row">
                    <div fxFlex.gt-sm="5%" fxFlex.lt-md="10%">
                      <mat-icon class="warn-text" style="font-size: 24px;">error</mat-icon>
                    </div>
                    <div fxFlex.gt-sm="95%" fxFlex.lt-md="90%">
                      The Contractor has declined your document upload request ({{getFormattedDate(application.contractorInvitationDate)}}).
                      You will need to upload the EBB documentation required to your Property Owner Dashboard or mail them directly to EBB.
                      You are also welcome to use another contractor.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="!isContractor() && !retrofitContractor?.contractorManualEntry && application.contractorInvitationCode !== 700000003 && IsContractorInDirectory() && checkUploadAuthorization() === 3">
              <br fxShow.lt-md />

              <span
                style="font-size: 14px"
                [ngClass]="{'form-strong': application.contractorInvitationCode === 700000000}">
                Would you like your selected contractor to upload retrofit documents and update information on your behalf?
                <br/>
                <small style="font-size: 12px;">(e.g., house photos, receipts, permit). 
                  Please note, if you give your contractor permission, 
                  they will be able to view any information you uploaded regarding proof of residency 
                  (e.g., driver's license, utility bill, deed).</small>
              </span>
              <div
                *ngIf="checkUploadAuthorization() === 3">
                <div style="margin-top: 6px;">
                  <mat-radio-group
                    required id="contractorInvitation"
                    name="contractorInvitation"
                    formControlName="contractorInvitation">
                    <mat-radio-button
                      value="700000001"
                      [checked]="taskRetrofitContractorGrantPerm === 700000001"
                      (click)="onClickManageContractorPermission(700000001, application.programType)">
                      Yes
                    </mat-radio-button>
                    <mat-radio-button
                      value="700000002"
                      [checked]="taskRetrofitContractorGrantPerm === 700000002 || taskRetrofitContractorGrantPerm === 700000003"
                      (click)="onClickManageContractorPermission(700000002, application.programType)">
                      No
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <br>
            <mat-card appearance="outlined" *ngIf="isAuthorizedAndRequiredBid()">
              <h6>CONTRACTOR ESTIMATE</h6>
              <div *ngIf="isAuthorizedAndRequiredBid()" style="display: flex; flex-direction: column; gap: 12px; margin-top: 28px;">
                <!-- Buttons Section -->
                <div style="display: flex; flex-wrap: wrap; gap: 12px; align-items: center;">
                  <button (click)="onSubmitBidEvent('1stBid')" mat-stroked-button color="primary">
                    {{ displayFirstBidLabel }}
                  </button>
                  <button
                    *ngIf="isSecondBidVisible && !isSecondBidEditMode"
                    (click)="onOpenDirectoryEvent('2ndBid')"
                    mat-stroked-button
                    color="primary">
                    SUBMIT SECOND ESTIMATE
                  </button>
                  <button
                    *ngIf="isSecondBidVisible && isSecondBidEditMode"
                    (click)="onSubmitBidEvent('2ndBidEdit')"
                    mat-stroked-button
                    color="primary">
                    EDIT SECOND ESTIMATE
                  </button>
                </div>
              
                <!-- Progress Bar -->
                <div *ngIf="saveBidProgressIndicator" style="margin-top: 12px; display: flex; justify-content: center;">
                  <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
                </div>
              </div>
              <div *ngIf="bid1rejected" style="white-space: normal;">
                <span class="warn-text">
                  Action required
                </span>
                <span style="white-space:nowrap;">
                  (<a style='color: #29637C; font-size: 16px; font-weight: 400;'
                    href="javascript:void(0)"
                     (click)='onClickShowReasonWhy(bid1rejectedwhy)'>read why</a>)
                </span>
              </div>
  
            </mat-card>
            <br>
            <!-- <mat-card appearance="outlined" *ngIf="isAuthorizedAndRequiredEngineeredBid()">
              <h6>ENGINEER ESTIMATE</h6>
            
            <div *ngIf="isAuthorizedAndRequiredEngineeredBid()" style="display: flex; flex-direction: column; gap: 12px; margin-top: 28px;">
             
              <div style="display: flex; flex-wrap: wrap; gap: 12px; align-items: center;">
                <button (click)="onSubmitEnggBidEvent('1stBid')" mat-stroked-button color="primary">
                  {{ displayFirstEngBidLabel }}
                </button>
                <button
                  *ngIf="isSecondEngBidVisible && !isSecondEngBidEditMode"
                  (click)="onSubmitEnggBidEvent('2ndBid')"
                  mat-stroked-button
                  color="primary">
                  SUBMIT SECOND ESTIMATE
                </button>
                <button
                  *ngIf="isSecondEngBidVisible && isSecondEngBidEditMode"
                  (click)="onSubmitEnggBidEvent('2ndBidEdit')"
                  mat-stroked-button
                  color="primary">
                  EDIT SECOND ESTIMATE
                </button>
              </div>
            
         
              <div *ngIf="saveEngBidProgressIndicator" style="margin-top: 12px; display: flex; justify-content: center;">
                <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
              </div>
            </div>
           </mat-card> -->
            <div *ngIf="isAuthorizedAndRequiredBid()" style="display: flex; gap: 12px;">
              <button
                mat-stroked-button
                color="primary"
                (click)="onContractorReviewEvent()">
                WRITE A CONTRACTOR REVIEW
              </button>
            </div>
            
          
            <div
              *ngIf="checkUploadAuthorization() === 3"
              style="margin-top: 12px;">

              <button
                [hidden]="application.programCycle.bidMustSubmitDoc !== undefined && application.programCycle.bidMustSubmitDoc !== null && application.programCycle.bidMustSubmitDoc === true"
                mat-stroked-button
                color="primary"
                (click)="onContractorReviewEvent()">
                <span>
                  WRITE A CONTRACTOR REVIEW
                </span>
              </button>

              <a *ngIf="contractorAllowManual()"
                class="retrofit-task-inline-action-link"
                style="width: 200px;"
                href="javascript:void(0)"
                (click)="onContractorUnlistedEvent()">
                <mat-icon style="font-size: 11px;">add</mat-icon>
                <span style="position: absolute; margin-left: -6px;">
                  Add contractor manually
                </span>
              </a>

              <a href="javascript:void(0)"
                matTooltip="Click for more actions..."
                class="retrofit-task-inline-action-link"
                style="width: 175px; margin-top: 5px;"
                [matTooltipPosition]="'below'"
                [matMenuTriggerFor]="menuContractorMoreActions">

                <mat-icon style="font-size: 13px;">more_vert</mat-icon>
                <span style="position: absolute; margin-left: -6px; margin-top: -1px;">
                  MORE ACTIONS
                </span>

                <mat-menu #menuContractorMoreActions='matMenu'>
                  <button mat-menu-item
                    (click)="onOpenDirectoryEvent('intro')">
                    <mat-icon>
                      edit
                    </mat-icon>
                    <span>
                      CHANGE CONTRACTOR
                    </span>
                  </button>

                  <button mat-menu-item
                    (click)="onChangeEventContractorSwitch(700000001)"
                     *ngIf="isDoItMyselfVisible()">
                    <mat-icon>
                      edit
                    </mat-icon>
                    <span>
                      CHANGE TO DO IT MYSELF
                    </span>
                  </button>

                </mat-menu>
              </a>

            </div>

            <div
              *ngIf="checkUploadAuthorization() === 2"
              style="margin-top: 12px;">

              <button
                mat-stroked-button mat-primary
                color="primary"
                (click)="onContractorReviewEvent()">
                <span>
                  WRITE A CONTRACTOR REVIEW
                </span>
              </button>
            </div>
          </div>
          <ng-template #searchContractor>
            <div style="margin-bottom: 9px;">
              Search our directory to select a contractor or send one or more requests for an estimate.
            </div>
            <div>
              <button mat-stroked-button color="primary"
                ngStyle.lt-md="{'margin-top': '6px'}"
                (click)="onOpenDirectoryEvent('intro')">
                FIND & SELECT CONTRACTOR
              </button>
            </div>
            <div
              *ngIf="checkUploadAuthorization() === 3"
              style="margin-top: 18px;">
              <a *ngIf="contractorAllowManual()"
                class="retrofit-task-inline-action-link"
                style="width: 225px;"
                href="javascript:void(0)"
                (click)="onContractorUnlistedEvent()">
                <mat-icon style="font-size: 11px;">add</mat-icon>
                <span style="position: absolute; margin-left: -6px;">
                  Add contractor manually
                </span>
              </a>
              <a
                class="retrofit-task-inline-action-link"
                style="width: 225px;"
                href="javascript:void(0)"
                (click)="onChangeEventContractorSwitch(700000001)"
                *ngIf="isDoItMyselfVisible()">
                <mat-icon style="font-size: 11px;">edit</mat-icon>
                <span style="position: absolute; margin-left: -6px;">
                  Change to Do it Myself
                </span>
              </a>
            </div>
          </ng-template>
        </div>
        <div *ngSwitchCase="700000001">
          <div style="margin-bottom: 9px;">
            You have chosen to do the retrofit yourself.
          </div>
          <a *ngIf="showesstraining"
            mat-stroked-button
            color="primary"
            (click)="redirectToESSTraining()"
          >
            LEARN HOW TO DO IT YOURSELF
          </a>
          <a *ngIf="!showesstraining"
          mat-stroked-button
          color="primary"
          (click)="redirectToEBBTraining()"
        >
          LEARN HOW TO DO IT YOURSELF
        </a>
          <div
            *ngIf="checkUploadAuthorization() === 3"
            style="margin-top: 12px;">
            <a
              class="retrofit-task-inline-action-link"
              href="javascript:void(0)"
              style="width: 250px;"
              (click)="onChangeEventContractorSwitch(700000000)">
              <mat-icon style="font-size: 11px;">edit</mat-icon>
              <span style="position: absolute; margin-left: -6px;">
                Change to Hire a Contractor
              </span>
            </a>
          </div>
        </div>
        <div *ngSwitchCase="0">
          <mat-radio-group
            id="contactorType"
            name="contractorType"
            formControlName="contractorType"
            (change)="onChangeEventContractor($event)">
            <div>
              <mat-radio-button value="700000000">
                Hire a Contractor
              </mat-radio-button>
            </div>
            <div style="margin-top: 6px;" *ngIf="isDoItMyselfVisible()">
              <mat-radio-button value="700000001">
                Do It Myself
              </mat-radio-button>
            </div>
          </mat-radio-group>
          <div *ngIf="formAutoSave" style="display: block; margin-top: 12px;">
            <mat-progress-bar
              mode="indeterminate"
              style="width: 300px;">
            </mat-progress-bar>
          </div>
        </div>
        <!-- <ebb-portal-contractor-sg-form 
        *ngIf="isSgQualify()"
          [application]="application"
          [taskSG]="taskSG"
          [w9Shown]="w9Shown"
          (emitFileUploadEvent)="onEmitBidInvoiceFileUploadEvent($event)"
          (emitBidInvoiceApplicationChangeEvent)="onEmitBidInvoiceApplicationChangeEvent($event)"
          (emitBidInvoiceChoiceEvent)="onEmitBidInvoiceChoiceEvent($event)">
        </ebb-portal-contractor-sg-form> -->
      </div>
    </div>
  </form>
</div>
